import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type {
  RequestStatusChangeData,
  RequestStatusChangeQueryVars,
  UseRequestStatusChangeParams,
} from './types';
import { getRequestStatusChangeMutationKey } from './util';

export const useRequestStatusChange: MutationFunction<
  RequestStatusChangeData,
  RequestStatusChangeQueryVars,
  [UseRequestStatusChangeParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { quoteId } = params;
  const urlPath = `/quotes/${quoteId}/request_status_change`;
  const mutationKey = getRequestStatusChangeMutationKey(params);
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (requestData) => {
      return request(urlPath, {
        init: {
          method: 'PATCH',
          body: requestData,
        },
      });
    },
    ...queryOptions,
    mutationKey,
  });
};
